module.exports = __webpack_public_path__ + "img/5.481cffd7.svg";